// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dw","header":"dx","title":"dy","description":"dz","button":"dA"};